"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.parse-int.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("react-input-range/lib/css/index.css");
var _reactInputRange = _interopRequireDefault(require("react-input-range"));
var _formElements = require("@evidation/form-elements");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var DEFALUT_BOTTOM_SPACING = 10;
var MIN_VALUE = 0;
var MAX_VALUE = 200;
var Slider = _styledComponents["default"].div.withConfig({
  displayName: "rangeHorizontal__Slider"
})(["margin-bottom:", ";"], function (props) {
  return props.fieldSpacing ? "".concat(props.fieldSpacing + DEFALUT_BOTTOM_SPACING, "px") : DEFALUT_BOTTOM_SPACING;
});
Slider.Styles = _styledComponents["default"].div.withConfig({
  displayName: "rangeHorizontal__Styles"
})(["height:65px;padding:20px 5px 0;"]);
var RangeSlider = /*#__PURE__*/function (_React$PureComponent) {
  function RangeSlider() {
    var _this;
    (0, _classCallCheck2["default"])(this, RangeSlider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RangeSlider, [].concat(args));
    (0, _defineProperty2["default"])(_this, "onChange", function (value) {
      // covering the case where min or max goes beyond it's range
      if (value.min < MIN_VALUE) {
        value.min = MIN_VALUE;
      }
      if (value.max > MAX_VALUE) {
        value.max = MAX_VALUE;
      }
      _this.props.input.onChange(value);
    });
    return _this;
  }
  (0, _inherits2["default"])(RangeSlider, _React$PureComponent);
  return (0, _createClass2["default"])(RangeSlider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$input = _this$props.input,
        value = _this$props$input.value,
        onBlur = _this$props$input.onBlur,
        onDragStart = _this$props$input.onDragStart,
        onDrop = _this$props$input.onDrop,
        onFocus = _this$props$input.onFocus,
        label = _this$props.label,
        description = _this$props.description,
        fieldSpacing = _this$props.fieldSpacing;

      // covering the case where the default value is not what the component expects
      if (_lodash["default"].isString(value) || _lodash["default"].isEmpty(value) || _lodash["default"].isUndefined(value)) {
        value = {
          min: 0,
          max: 5
        };
      }
      return /*#__PURE__*/_react["default"].createElement(Slider, {
        fieldSpacing: parseInt(fieldSpacing, 10)
      }, label && /*#__PURE__*/_react["default"].createElement("label", {
        classname: "label"
      }, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, label)), /*#__PURE__*/_react["default"].createElement(Slider.Styles, null, /*#__PURE__*/_react["default"].createElement(_reactInputRange["default"], {
        draggableTrack: true,
        maxValue: MAX_VALUE,
        minValue: MIN_VALUE,
        value: value,
        onChange: this.onChange,
        onChangeStart: function onChangeStart() {
          onFocus();
          onDragStart();
        },
        onChangeComplete: function onChangeComplete() {
          onDrop();
          onBlur();
        }
      })), description && /*#__PURE__*/_react["default"].createElement("label", {
        className: "description",
        fullWidth: true
      }, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, description)));
    }
  }]);
}(_react["default"].PureComponent);
RangeSlider.defaultProps = {
  input: _propTypes["default"].object.isRequired,
  label: _propTypes["default"].string,
  description: _propTypes["default"].string,
  fieldSpacing: _propTypes["default"].number
};
RangeSlider.propTypes = {
  fieldSpacing: 0,
  label: undefined,
  description: undefined
};
var _default = exports["default"] = RangeSlider;